import { useEffect } from 'react'
import { useEchoClient } from './echoClient'
import { useDashboardStore } from '@/stores/dashboardStore'
import type { DashboardWidgetUpdatedEvent } from '@/types/dashboard'

/**
 * Realtime-актуализация дашборда: сервер шлёт «виджет устарел»
 * на приватный канал user.{id}.dashboard, SPA рефетчит только его.
 */
export function useDashboardRealtime(userId: number | null): void {
  const refetchWidget = useDashboardStore((state) => state.refetchWidget)
  // Клиент — зависимость эффекта: после пересоздания Echo подписка иначе
  // осталась бы на отключённом сокете.
  const echo = useEchoClient()

  useEffect(() => {
    if (!userId) return

    const channelName = `user.${userId}.dashboard`
    const channel = echo.private(channelName)

    channel.listen('.dashboard.widget.updated', (event: DashboardWidgetUpdatedEvent) => {
      void refetchWidget(event.widget_key)
    })

    return () => {
      echo.leave(channelName)
    }
  }, [echo, refetchWidget, userId])
}
